module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/fin/costcenters/costcenters-show/costcenters-show.component.scss
// module id = ./src/app/views/fin/costcenters/costcenters-show/costcenters-show.component.scss
// module chunks = main